import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolTeachersCertified = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t('service.school.certifiedTeachers.explanations.title.certified')}
          </h2>
          <p className="school-section-description">
            {t(
              'service.school.certifiedTeachers.explanations.detail.certified',
            )}
          </p>
        </div>
        <div className="col-span-12 lg:col-span-5 md:col-span-6">
          <Image
            alt="LingualBox Tutors"
            width={360}
            height={268}
            className="flex-image"
            src="/images/teachers.png"
          />
        </div>
      </div>
    </div>
  );
};

export default SchoolTeachersCertified;
